import { cr } from "fire-wind-water";
import { ObserverProxy } from "./observer";
import { Directive } from "./directive";

class Lifecycle {
  private modules: {
    [label: string]: { bootstrap: boolean; modules: any[]; injection: any[] };
  } = {};

  constructor() {}

  static add<T>(list: T, c = 0): T {
    const modules: any[] = [];
    cr.each(list, (d) => {
      @ObserverProxy
      @Directive()
      class M extends d {
        $$directive: { [label: string]: any[] } = {};

        constructor() {
          super();
          this.observer();
        }
      }

      const m = new M();
      m.$$skCore = c;
      modules.push(m);
    });
    return modules as unknown as T;
  }

  static onInit(target): void {
    cr.each(target.modules, (d) => {
      if (d.bootstrap && d.modules.length === 0) {
        d.modules = Lifecycle.add(d.injection);
      }
    });
  }

  static destroy(target, s): void {
    cr.each(target.modules[s].modules, (m) => {
      cr.each(m.$$directive, (c) => {
        c.splice(0, c.length);
      });
    });
    target.modules[s].modules = [];
  }

  create(key: string, modules: any[]): void {
    if (this.modules[key]) {
      this.modules[key].injection = modules;
    } else {
      this.modules[key] = {
        bootstrap: false,
        modules: [],
        injection: modules,
      };
    }
  }

  bootstrap(key: string): void {
    if (this.modules[key]) {
      this.modules[key].bootstrap = true;
      this.modules[key].modules = Lifecycle.add(this.modules[key].injection);
    }
  }

  transfer(s: string, ...args): void {
    cr.each(this.modules, (d) => {
      if (d.bootstrap) {
        cr.each(d.modules, (o) => {
          if (cr.isFunction(o[s])) {
            o[s](args);
          }
        });
      }
    });
  }

  transferKey(key: string, s: string, ...args): void {
    if (this.modules[key]?.bootstrap) {
      cr.each(this.modules[key].modules, (o) => {
        if (cr.isFunction(o[s])) {
          o[s](args);
        }
      });
    }
  }

  // 实例化后调用
  private skOnInit(...args): void {
    this.transfer("skOnInit", args);
  }

  // 数据变化后触发
  private skOnChange(...args): void {
    this.transfer("skOnChange", args);
  }

  // 事件通知
  private skEventChange(...args): void {
    this.transfer("skEventChange", args);
  }

  // dom渲染后调用，只调用一次
  private skAfterViewInit(...args): void {
    this.transfer("skAfterViewInit", args);
  }

  // 解析指令及数据变更后的执行，在skAfterViewInit后调用，调用多次
  private skAfterViewChecked(...args): void {
    Lifecycle.onInit(this);
    this.transfer("skAfterViewChecked", args);
  }

  // 更新视图绑定用
  private skUpdateView(...args): void {
    Lifecycle.onInit(this);
    this.transfer("skUpdateView", args);
  }

  // 图片加载完
  private skAfterContentInit(...args): void {
    this.transfer("skAfterContentInit", args);
  }
  // 销毁时触发
  private skOnDestroy(s = "", ...args): void {
    if (s) {
      this.transferKey(s, "skOnDestroy", args);
      Lifecycle.destroy(this, s);
    } else {
      cr.each(this.modules, (d, k) => {
        this.transferKey(k, "skOnDestroy", args);
        Lifecycle.destroy(this, k);
      });
    }
  }
}

export { Lifecycle };
